import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <FaqSection />
        <FeaturesSection />
        <CommentsSection />
        <AboutSection />
        <IndexSection />
        <AppSection />
        <CarouselSection />
        <ContactSection />
        <CardsSection />
        <RankingSection />
        <UpdatesSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}